export const resolveStringToWindowObject = (str: string, createIfNotExists?: boolean) => {
    var basis = window;
    if (!str) {
      return null;
    } else if (typeof str === "function") {
      return str;
    } else {
      var last = basis,
        names = str.split("."),
        name,
        i,
        j;
      for (i = 0, j = names.length; i < j; i++) {
        name = names[i];
        basis = basis[name];
        if (!basis) {
          if (createIfNotExists) {
            basis = last[name] = {};
          } else {
            return null;
          }
        }
        last = basis;
      }
    }
    return basis;
  };